import type { AppModule } from '@/config/maintenanceModules';

export interface AppRouteMeta {
    module?: AppModule;
    requiresAuth?: boolean;
    allowedUsers?: number[];
    breadcrumb?: Array<{
        title: string;
        name: string;
        icon: string;
    }>;
}

export function buildRouteMeta(
    module: AppModule,
    meta: Omit<AppRouteMeta, 'module'> = {}
): AppRouteMeta {
    return {
        ...meta,
        module,
    };
}
